import {
  MessageCircle,
  Zap,
  Brain,
  Puzzle,
  GitBranch,
  Rocket,
  Bot,
  Workflow,
  type LucideIcon,
} from "lucide-react";

export interface PowerUpDef {
  id: string;
  label: string;
  description?: string;
  icon?: LucideIcon;
  doc?: string;
  stock: boolean;
  listingId?: string;
}

const STOCK_POWER_UPS: PowerUpDef[] = [
  {
    id: "channels",
    label: "Channels",
    description: "Talk to your AI from WhatsApp, Telegram, Discord, Slack",
    icon: MessageCircle,
    doc: "Webhook URL is in Settings after you add this.",
    stock: true,
  },
  {
    id: "actions",
    label: "Actions",
    description: "AI can send email, manage calendar, check in for flights",
    icon: Zap,
    doc: "Uses inbox, email, calendar, and flight actions.",
    stock: true,
  },
  {
    id: "memory",
    label: "Persistent memory",
    description: "AI remembers you 24/7 across sessions",
    icon: Brain,
    doc: "Stores preferences and facts; injects into every chat.",
    stock: true,
  },
  {
    id: "skills",
    label: "Skills",
    description: "Add custom skills or use community skills",
    icon: Puzzle,
    doc: "Register skills in Settings or via API.",
    stock: true,
  },
  {
    id: "workflows",
    label: "Workflows",
    description: "Automate with triggers and actions (Zapier-style)",
    icon: GitBranch,
    doc: "Webhook and schedule triggers in Settings.",
    stock: true,
  },
  {
    id: "deploy",
    label: "One-click deploy",
    description: "Deploy your AI or apps to Netlify",
    icon: Rocket,
    doc: "Uses Netlify when enabled.",
    stock: true,
  },
  {
    id: "replitAgent",
    label: "App from idea",
    description: "Describe an app in words → build & deploy",
    icon: Bot,
    doc: "Replit-style: goal → spec → build → deploy.",
    stock: true,
  },
  {
    id: "agenticWorkflows",
    label: "Agentic workflows",
    description: "Multi-step agents with tools: do A, B, C, D, E—or use Shopify, generate, and more",
    icon: Workflow,
    doc: "Build workflows with steps and tools; the AI runs them in order. Enable and configure in Power-ups.",
    stock: true,
  },
];

export async function getPowerUpsForBuilder(_userId: string): Promise<PowerUpDef[]> {
  return STOCK_POWER_UPS;
}

export async function getUnlockedPowerUpListingIds(_userId: string): Promise<Set<string>> {
  return new Set();
}
